import { render, staticRenderFns } from "./UserProfilePanel.vue?vue&type=template&id=07515a21&scoped=true&"
import script from "./UserProfilePanel.vue?vue&type=script&lang=js&"
export * from "./UserProfilePanel.vue?vue&type=script&lang=js&"
import style0 from "./UserProfilePanel.vue?vue&type=style&index=0&id=07515a21&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "07515a21",
  null
  
)

export default component.exports